import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { DEFAULT_PERMISSION_DETAILS, PRIVATE } from '../../getCheckedOptionFromView';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrivateRadioOption = ({
  checkedOption,
  setCheckedOption,
  setViewUpdates
}) => {
  const isChecked = checkedOption === PRIVATE;
  const onRadioChange = useCallback(() => {
    setCheckedOption(PRIVATE);
    setViewUpdates({
      teamId: undefined,
      private: true,
      permissionDetails: DEFAULT_PERMISSION_DETAILS
    });
  }, [setCheckedOption, setViewUpdates]);
  return /*#__PURE__*/_jsx(UIRadioInput, {
    checked: isChecked,
    onChange: onRadioChange,
    "data-test-id": `view-sharing-private-checked=${isChecked}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.private"
    })
  });
};